module.exports = __webpack_public_path__ + "static/media/f_hairstyle_curly_medium_front.2cfba7af.png";